module.exports = __webpack_public_path__ + "website/img/func2.309d6671.png";